import { FC, useEffect, useState } from 'react'

import { LoopBanner } from '../../../app/_components/chrome/LoopBanner.client'
import { NextLink } from '../../../app/_components/navigation/NextLink'
import { useLoop } from '../../../app/_providers/LoopProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { NavContainer } from '../../../brunswick/containers/NavContainer'
import { useSearchOverlayContext } from '../../../containers/SearchOverlayContext'
import { disableScroll, enableScroll } from '../../../lib/utils'

import { NavHeaderCenter } from './NavHeaderCenter'
import { NavHeaderIcons } from './NavHeaderIcons'
import { NavHeaderLeft } from './NavHeaderLeft'
import { Body, ScreenReaderOnlyLink, Wrapper } from './styles'

export const NavHeader: FC = () => {
  const {
    magnolia: { navigation: strings },
  } = useTranslation()
  const { isHeaderPushedUp } = NavContainer.useContainer()
  const { inLoopFlow } = useLoop()

  const { shouldDisplaySearchOverlay } = useSearchOverlayContext()
  const isFadedOut = shouldDisplaySearchOverlay
  const freezeTabId = shouldDisplaySearchOverlay ? 'search' : undefined

  const [searchResults] = useState<boolean>(false)

  useEffect(() => {
    searchResults ? disableScroll() : enableScroll()
  }, [searchResults])

  return (
    <>
      <Wrapper
        $pushedUp={isHeaderPushedUp}
        $includesLoopBanner={inLoopFlow}
        data-testid='site-header'
        role='banner'
      >
        <LoopBanner />
        <Body>
          <ScreenReaderOnlyLink as={NextLink} href='/pages/accessibility'>
            {strings.accessibilityLink}
          </ScreenReaderOnlyLink>

          <NavHeaderLeft isFadedOut={isFadedOut} />
          <NavHeaderCenter isFadedOut={isFadedOut} />
          <NavHeaderIcons freezeTabId={freezeTabId} />
        </Body>
      </Wrapper>
    </>
  )
}
